export default "\r\n<!--<app-ctl-about-us></app-ctl-about-us>-->\r\n\r\n\r\n"